// 단일 생성에서 '다음 학생 쓰기'를 보여 주는 영역. 결과 하나가 학생 한 명인 영역만 해당한다
// (교과·창체 단일은 버전이 성취수준별/여러 학생이라 반 단위 결과다).
export const NEXT_STUDENT_CATEGORIES = new Set(['행동발달', '교과_고등', '동아리', '진로']);

export const supportsNextStudent = (category) => NEXT_STUDENT_CATEGORIES.has(category);

// 학생마다 다른 입력만 비우고, 반 공통 입력(성취기준·동아리 설명·계획서)과 설정은 그대로 둔다.
export const nextStudentGenerationData = (prev) => ({ ...prev, prompt: '', emphasizePoints: [] });

export const nextStudentHighSchoolData = (prev) => ({
  ...prev,
  growthPoints: '',
  studentActivity: '',
  files: [],
  filesContent: [],
  filesStats: [],
});

export const nextStudentClubData = (prev) => ({
  ...prev,
  studentActivity: '',
  studentFiles: [],
  studentFilesContent: [],
  studentFilesStats: [],
});

export const nextStudentCareerData = () => ({
  studentActivity: '',
  studentFiles: [],
  studentFilesContent: [],
  studentFilesStats: [],
  careerInfo: '',
  infoFile: null,
  infoFileContent: null,
});
